module.exports = __webpack_public_path__ + "static/media/6l_website_logo_Platinum_WSP.cf5f7db1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6l_website_logo_Platinum_WSP.jpg
// module id = 107
// module chunks = 0